import axios from "axios";
import { cartCountUrl, tieredRuleUrl } from "./constant";
import { getAuthToken } from "./common";
export const getCartCount = async (
  activityId: string | number,
  onSucess: Function,
  customerStNumber?: string
) => {
  try {
    const cartCountRequestUrl = customerStNumber
      ? `${cartCountUrl}?activityId=${activityId}&customerStNumber=${customerStNumber}`
      : `${cartCountUrl}?activityId=${activityId}`;
    const resp = await axios(cartCountRequestUrl, {
      method: "GET",
      headers: {
        Authorization: getAuthToken(),
        "Content-Type": "application/json",
      },
    });
    if (resp.status === 200) {
      const respData = resp.data;
      console.log("getCartCount respData", respData);
      if (respData.status === "success") {
        // setCartCount(respData.data || 0);
        onSucess(respData.data || 0);
      }
    }
  } catch (err) {
    console.log(err);
  }
};

export const getTieredRule = async (
  activityId: string | number,
  onSucess: Function
) => {
  if (!activityId) return;
  try {
    const resp = await axios(`${tieredRuleUrl}?activityId=${activityId}`, {
      method: "GET",
      headers: {
        Authorization: getAuthToken(),
        "Content-Type": "application/json",
      },
    });
    if (resp.status === 200) {
      const respData = resp.data;
      console.log("getTieredRule respData", respData);
      if (respData.status === "success") {
        onSucess(respData.data);
      }
    }
  } catch (err) {
    console.log(err);
  }
};
